import styled from '@emotion/styled'
import { css } from '@emotion/react'

const sizesDictionary = {
  small: {
    h1: { size: 'giga' },
    h2: { size: 'mega' },
    h3: { type: 'text' },
    h4: { weight: 'regular' }
  },
  medium: {
    h1: { size: 'tera' },
    h2: { size: 'giga' },
    h3: { type: 'headings' },
    h4: { weight: 'semibold' }
  }
}

const descriptionStyles = ({ theme, type = 'medium' }) => {
  const { h1, h2, h3, h4 } = sizesDictionary[type]

  return css`
    label: description;

    font-size: ${theme.typography.text.mega.fontSize};
    line-height: ${theme.typography.text.mega.lineHeight};

    margin-bottom: ${theme.spacings.giga};

    ul {
      label: description__list;

      font-size: ${theme.typography.text.mega.fontSize};

      list-style-type: disc;

      padding-left: ${theme.spacings.mega};

      li {
        label: description__list__item;

        margin-bottom: ${theme.spacings.byte};
      }
    }

    ol {
      label: description__ordered-list;

      margin-bottom: ${theme.spacings.mega};
      margin-top: ${theme.spacings.mega};
      padding: 0 ${theme.spacings.peta};
    }

    h1 {
      label: description__heading__one;

      font-size: ${theme.typography.headings[h1.size].fontSize};
      line-height: ${theme.typography.headings.tera.lineHeight};
      font-weight: ${theme.font.weight.semibold};

      margin-bottom: ${theme.spacings.byte};
      margin-top: ${theme.spacings.giga};
    }

    h2 {
      label: description__heading__two;

      font-size: ${theme.typography.headings[h2.size].fontSize};
      line-height: ${theme.typography.headings[h2.size].lineHeight};
      font-weight: ${theme.font.weight.semibold};

      margin-bottom: ${theme.spacings.byte};
      margin-top: ${theme.spacings.giga};
    }

    h3 {
      label: description__heading__three;

      font-size: ${theme.typography[h3.type].mega.fontSize};
      line-height: ${theme.typography[h3.type].mega.lineHeight};
      font-weight: ${theme.font.weight.semibold};

      margin-bottom: ${theme.spacings.byte};
      margin-top: ${theme.spacings.giga};
    }

    h4 {
      label: description__heading__four;

      font-weight: ${theme.font.weight[h4.weight]};
    }

    p {
      label: description__text;

      display: block;

      font-size: ${theme.typography.text.mega.fontSize};
      line-height: ${theme.typography.text.mega.lineHeight};

      margin-bottom: ${theme.spacings.kilo};
      margin-top: ${theme.spacings.kilo};
    }

    u {
      label: description__unarticulated;

      text-decoration: underline;
    }

    strong {
      label: description__text__strong;

      font-weight: ${theme.font.weight.bold};
    }

    em {
      label: description__text__emphasis;

      font-style: italic;
    }

    blockquote {
      label: description__text__blockquote;

      margin-bottom: ${theme.spacings.mega};
      margin-top: ${theme.spacings.mega};
      padding-left: ${theme.spacings.peta};
    }
  `
}

export const Description = styled('div')(descriptionStyles)
